import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import Blogs from '../views/Blogs.vue'
import ScriptureView from '@/views/ScriptureView.vue'
import BooksView from '@/views/BooksView.vue';
import AdminDashboard from '@/views/AdminDashboard.vue'

Vue.use(VueRouter)

const routes = [

  {
    path: '/login',
    name: 'Login',
    component: LoginView,
   meta: { requiresAuth: false }
  },

  {
    path: '/',
    name: 'home',
    component: HomeView
  },

  {
    path: '/admin',
    name: 'admin',
    component: AdminDashboard
  },

  {
    path: '/blog',
    name: 'Blogs',
    component: Blogs
  },
  {
    path: '/books',
    name: 'BooksView',
    component: BooksView
  },

  {
  path: '/scripture',
  name: 'Scripture',
  component: ScriptureView
},

  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
